import { call, put, takeLatest } from '@redux-saga/core/effects'

import { api, API } from 'services'
import {
  GET_DEFAULT_VARIABLES_REQUEST,
  UPDATE_DEFAULT_VARIABLES_REQUEST,
  GET_REGISTRATION_MESSAGES_REQUEST,
  UPDATE_REGISTRATION_MESSAGES_REQUEST,
  getDefaultVariablesError,
  getDefaultVariablesSuccess,
  updateDefaultVariablesSuccess,
  updateDefaultVariablesError,
  updateDefaultVariablesRequest,
  updateRegistrationMessagesRequest,
  updateRegistrationMessagesSuccess,
  updateRegistrationMessagesError,
  getRegistrationMessagesSuccess,
  getRegistrationMessagesError
} from 'store'

export function* getDefaultVariablesSaga() {
  try {
    const { data } = yield call(api, API.DEFAULT_VARIABLES)

    yield put(getDefaultVariablesSuccess(data))
  } catch (e: any) {
    yield put(getDefaultVariablesError(e))
  }
}

export function* updateDefaultVariablesSaga(
  action: ReturnType<typeof updateDefaultVariablesRequest>
) {
  try {
    yield call(api, API.UPDATE_DEFAULT_VARIABLES, {
      method: 'PATCH',
      data: action.payload
    })

    yield put(updateDefaultVariablesSuccess())
  } catch (e: any) {
    yield put(updateDefaultVariablesError(e))
  }
}

export function* getRegistrationMessagesSaga() {
  try {
    const { data } = yield call(api, API.REGISTRATION_MESSAGES, {
      method: 'GET'
    })

    yield put(getRegistrationMessagesSuccess(data))
  } catch (e: any) {
    yield put(getRegistrationMessagesError(e))
  }
}

export function* updateRegistrationMessagesSaga(
  action: ReturnType<typeof updateRegistrationMessagesRequest>
) {
  try {
    yield call(api, API.REGISTRATION_MESSAGES, {
      method: 'PATCH',
      data: action.payload
    })

    yield put(updateRegistrationMessagesSuccess())
  } catch (e: any) {
    yield put(updateRegistrationMessagesError(e))
  }
}

export function* defaultVariablesSaga() {
  yield takeLatest(GET_DEFAULT_VARIABLES_REQUEST, getDefaultVariablesSaga)
  yield takeLatest(UPDATE_DEFAULT_VARIABLES_REQUEST, updateDefaultVariablesSaga)
  yield takeLatest(GET_REGISTRATION_MESSAGES_REQUEST, getRegistrationMessagesSaga)
  yield takeLatest(UPDATE_REGISTRATION_MESSAGES_REQUEST, updateRegistrationMessagesSaga)
}
